import type { Shape } from "~/types/grid.types";
import { SHAPE_IDS } from "./shapesIdsSquare";

export const CIRCLES_SQUARE_SHAPES: Shape[] = [
  {
    type: "arc",
    id: SHAPE_IDS.LARGE_HALF_CIRCLE_VERTICAL,
    icon: "LargeHalfCircleHorizontalFlipped",
    prefix: "LargeHalfCircle",
    label: "Large Half Circle",
    angle: 180,
    rotation: 90,
    imgRotation: 180,
    radius: 120,
    w: 120,
    h: 240,
    children: [
      {
        type: "arc",
        id: SHAPE_IDS.LARGE_HALF_CIRCLE_HORIZONTAL,
        icon: "LargeHalfCircleHorizontalFlipped",
        prefix: "LargeHalfCircle",
        label: "Large Half Circle Horizontal",
        angle: 180,
        rotation: 180,
        imgRotation: 180,
        radius: 120,
        w: 240,
        h: 120,
      },
      {
        type: "arc",
        id: SHAPE_IDS.LARGE_HALF_CIRCLE_VERTICAL_FLIPPED,
        icon: "LargeHalfCircleHorizontalFlipped",
        prefix: "LargeHalfCircle",
        label: "Large Half Circle Vertical Flipped",
        angle: 180,
        rotation: 270,
        imgRotation: 180,
        radius: 120,
        w: 120,
        h: 240,
      },
      {
        type: "arc",
        id: SHAPE_IDS.LARGE_HALF_CIRCLE_HORIZONTAL_FLIPPED,
        icon: "LargeHalfCircleHorizontalFlipped",
        prefix: "LargeHalfCircle",
        label: "Large Half Circle Horizontal Flipped",
        angle: 180,
        rotation: 0,
        imgRotation: 180,
        radius: 120,
        w: 240,
        h: 120,
      },
    ],
  },
  {
    type: "arc",
    id: SHAPE_IDS.QUARTER_CIRCLE_BOTTOM_LEFT,
    icon: "QuarterCircleBottomRight",
    prefix: "QuarterCircle",
    label: "Quarter Circle",
    angle: 90,
    rotation: 90,
    imgRotation: 180,
    radius: 120,
    w: 120,
    h: 120,
    children: [
      {
        type: "arc",
        id: SHAPE_IDS.QUARTER_CIRCLE_TOP_LEFT,
        icon: "QuarterCircleBottomRight",
        prefix: "QuarterCircle",
        label: "Quarter Circle Top Left",
        angle: 90,
        rotation: 180,
        imgRotation: 180,
        radius: 120,
        w: 120,
        h: 120,
      },
      {
        type: "arc",
        id: SHAPE_IDS.QUARTER_CIRCLE_BOTTOM_RIGHT,
        icon: "QuarterCircleBottomRight",
        prefix: "QuarterCircle",
        label: "Quarter Circle Bottom Right",
        angle: 90,
        rotation: 0,
        imgRotation: 180,
        radius: 120,
        w: 120,
        h: 120,
      },
      {
        type: "arc",
        id: SHAPE_IDS.QUARTER_CIRCLE_TOP_RIGHT,
        icon: "QuarterCircleBottomRight",
        prefix: "QuarterCircle",
        label: "Quarter Circle Top Right",
        angle: 90,
        rotation: 270,
        imgRotation: 180,
        radius: 120,
        w: 120,
        h: 120,
      },
    ],
  },
  {
    type: "arc",
    id: SHAPE_IDS.HALF_CIRCLE_VERTICAL,
    icon: "HalfCircleHorizontalFlipped",
    prefix: "HalfCircle",
    label: "Half Circle",
    angle: 180,
    rotation: 90,
    imgRotation: 180,
    radius: 60,
    w: 60,
    h: 120,
    children: [
      {
        type: "arc",
        id: SHAPE_IDS.HALF_CIRCLE_HORIZONTAL,
        icon: "HalfCircleHorizontalFlipped",
        prefix: "HalfCircle",
        label: "Half Circle Horizontal",
        angle: 180,
        rotation: 180,
        imgRotation: 180,
        radius: 60,
        w: 120,
        h: 60,
      },
      {
        type: "arc",
        id: SHAPE_IDS.HALF_CIRCLE_VERTICAL_FLIPPED,
        icon: "HalfCircleHorizontalFlipped",
        prefix: "HalfCircle",
        label: "Half Circle Vertical Flipped",
        angle: 180,
        rotation: 270,
        imgRotation: 180,
        radius: 60,
        w: 60,
        h: 120,
      },
      {
        type: "arc",
        id: SHAPE_IDS.HALF_CIRCLE_HORIZONTAL_FLIPPED,
        icon: "HalfCircleHorizontalFlipped",
        prefix: "HalfCircle",
        label: "Half Circle Horizontal Flipped",
        angle: 180,
        rotation: 0,
        imgRotation: 180,
        radius: 60,
        w: 120,
        h: 60,
      },
    ],
  },
  {
    type: "arc",
    id: SHAPE_IDS.SMALL_HALF_CIRCLE_VERTICAL,
    icon: "HalfCircleHorizontalFlipped",
    prefix: "SmallHalfCircle",
    label: "Small Half Circle",
    angle: 180,
    rotation: 90,
    imgRotation: 180,
    radius: 30,
    w: 30,
    h: 60,
    children: [
      {
        type: "arc",
        id: SHAPE_IDS.SMALL_HALF_CIRCLE_HORIZONTAL,
        icon: "HalfCircleHorizontalFlipped",
        prefix: "SmallHalfCircle",
        label: "Small Half Circle Horizontal",
        angle: 180,
        rotation: 180,
        imgRotation: 180,
        radius: 30,
        w: 60,
        h: 30,
      },
      {
        type: "arc",
        id: SHAPE_IDS.SMALL_HALF_CIRCLE_VERTICAL_FLIPPED,
        icon: "HalfCircleHorizontalFlipped",
        prefix: "SmallHalfCircle",
        label: "Small Half Circle Vertical Flipped",
        angle: 180,
        rotation: 270,
        imgRotation: 180,
        radius: 30,
        w: 30,
        h: 60,
      },
      {
        type: "arc",
        id: SHAPE_IDS.SMALL_HALF_CIRCLE_HORIZONTAL_FLIPPED,
        icon: "HalfCircleHorizontalFlipped",
        prefix: "SmallHalfCircle",
        label: "Small Half Circle Horizontal Flipped",
        angle: 180,
        rotation: 0,
        imgRotation: 180,
        radius: 30,
        w: 60,
        h: 30,
      },
    ],
  },
];
